import styled from 'styled-components';

const getPosition = ({ sticky }) => (sticky ? 'sticky' : 'static');

const StyledSidebarHeader = styled.header`
	flex: ${({ $isNew }) => ($isNew ? `0 0 auto` : `0 1 auto`)};
	position: ${getPosition};
	top: 0;
	left: 0;
`;

/**
 * Simple sticky (by default) sidebar header without styling
 */
const SimpleSidebarHeader = ({ children, className, sticky = true, isNew = false }) => (
	<StyledSidebarHeader sticky={sticky} className={className} $isNew={isNew}>
		{children}
	</StyledSidebarHeader>
);

export default SimpleSidebarHeader;
